import React, { useState } from "react"
import Button from "../material/button/Button"
import PageHeader from "../pageheader/PageHeader"
import ListDataPatient from "./ListDataPatient"
import MenuDoctor from "./navDoctor/MenuDoctor"
import StatusDataPatient from "./StatusDataPatient"

import styles from './ListDataPatient.module.css'

export default function DataAccessRights() {
    const [toggle, setToggle] = useState('listDataPatient')

    return (
      <div class="flex w-full bg-[#ffffff] pb-[30px]">
        <div className={styles.blockContent}>
          <div
            className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
          >
            รายชื่อผู้ป่วยที่มีสิทธิเข้าถึงข้อมูล
          </div>
          <ListDataPatient />
        </div>
      </div>
    );
}

